import React, { Component } from "react";
import { connect } from "react-redux";
import { createUser, loginUser } from "../../reducers/user";
import { Form } from "../../components/forms/Form";
import Header from "../../components/header/HeaderLogin";

import "../../App.css";

class Password extends Component {
  state = {
    inputs: inputsRaw,
    // email: "ale.locaw@yahoo.it",
  };

  componentDidUpdate(oldProps, oldState) {
    if (oldProps.error !== this.props.error && this.props.error) {
      this.setState({
        inputs: this.state.inputs.map((input) => {
          if (input.target === "email") {
            return {
              ...input,
              error: this.props.error.response.data.message,
            };
          }
          return input;
        }),
      });
    }
  }

  _handleChangeInput = (target, value) => {
    this.setState({ [target]: value });
  };
  _handleSubmit = async () => {
    const { email } = this.state;
    // console.log(email);
  };
  _isDisabled = () => {
    const inputStatus = this.state.inputs.map(
      (input) => !!this.state[input.target] && this.state[input.target] !== ""
    );
    return typeof inputStatus.find((input) => !input) !== "undefined";
  };

  render() {
    // console.log(this.state);
    // console.log(this.props);
    const { inputs } = this.state;
    return (
      <div className="login-container">
        <div className="login-title-section">
          <h1 style={{ fontSize: 48 }}>Recupero Password</h1>
          <p>
            Inserisci la tua email per ricevere il link per resettare la tua
            password.
          </p>
        </div>
        <div className="login-form-buttons-container">
          <Form
            submitButton={{
              text: "INVIA",
              disabled: this._isDisabled(),
              loading: this.props.loading,
            }}
            inputs={inputs}
            handleChangeInput={this._handleChangeInput}
            handleSubmit={this._handleSubmit}
          />
          {/* <LoginButtons /> */}
        </div>
      </div>
    );
  }
}

const inputsRaw = [{ target: "email", placeholder: "Email", type: "email" }];

const mapStateToProps = (state) => ({
  user: state.user.data,
  loading: state.user.loading,
  error: state.user.error,
});

export default connect(mapStateToProps, { createUser, loginUser })(Password);
